import { useSuspenseQuery } from '@tanstack/react-query'

// eslint-disable-next-line boundaries/element-types
import { produtosKeys } from '@/features/produtos/utils/queries'
import type { TUnidadeTipoEnum } from '@/shared/interfaces/produto.enums'
import { GetProdutosService } from '@/shared/services/get-produtos.service'

export const useSuspenseProdutos = (idExternoBloco: number, tipoProduto: TUnidadeTipoEnum, isVagaPadrao?: boolean) => {
  return useSuspenseQuery({
    queryKey: produtosKeys.lista({ idExternoBloco, tipoProduto, isVagaPadrao }),
    queryFn: () =>
      new GetProdutosService().execute(idExternoBloco, tipoProduto, isVagaPadrao).then((response) => response.data),
  })
}
